import React, { ReactNode } from 'react';
import { makeStyles, Snackbar, Typography } from '@material-ui/core';
import ConfirmationIcon from '../../icons/confirmation-icon';

const styles = makeStyles(({ palette, spacing }) => ({
  snackbarStyles: {
    padding: `0px ${spacing(3)}px`,
    display: 'flex',
    alignItems: 'center',
    gap: spacing(3),
    justifyContent: 'flex-start',
  },
  iconStyles: {
    margin: `${spacing(3)}px 0px`,
    lineHeight: 0,
  },
  messageStyles: {
    margin: `${spacing(3)}px 0px`,
  },
  error: {
    backgroundColor: palette.error.light,
    color: palette.error.contrastMain,
  },
  success: {
    backgroundColor: palette.success.light,
    color: palette.success.contrastMain,
  },
}));

interface NewNotificationBannerProps {
  open: boolean;
  messages: string[];
  icon?: ReactNode;
  variant?: 'error' | 'success';
  onClose?: () => void;
  autoHideDuration?: number;
}

const NewNotificationBanner = ({
  open,
  messages,
  icon: inputIcon,
  variant = 'error',
  onClose,
  autoHideDuration,
}: NewNotificationBannerProps) => {
  const classes = styles();

  const icon = inputIcon || (variant === 'success' ? <ConfirmationIcon size="small" /> : null);
  const iconWrapper = icon ? <div className={classes.iconStyles}>{icon}</div> : null;

  return (
    <Snackbar
      autoHideDuration={autoHideDuration}
      open={open}
      onClose={onClose}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      className={`${classes.snackbarStyles} ${classes[variant]}`}
    >
      <>
        {iconWrapper}
        <div>
          {messages.map((message) => (
            <Typography variant="body2" key={message} className={classes.messageStyles}>
              {message}
            </Typography>
          ))}
        </div>
      </>
    </Snackbar>
  );
};

export default NewNotificationBanner;
